import { useState } from "react";
import CustomButton from "../../../helperComponents/CustomButton";
import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import goTo from "../../../../controllers/goTo";
import { serverLine } from "../../../../controllers/network/serverLine";
import LoadingSection from "../../../helperComponents/LoadingSection";

const Container = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default function NotificationToCertificatePostPopup({ notificationId }) {
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  if (loading)
    return (
      <Container>
        <LoadingSection />
      </Container>
    );

  return (
    <Container>
      <MaterialInput
        onTextChange={setDescription}
        value={description}
        label={"Description"}
        multiline={true}
        rows={4}
      />
      <CustomButton onClick={publishPost}>Publish to feed</CustomButton>
    </Container>
  );

  async function publishPost() {
    try {
      setLoading(true);
      await serverLine.post("/convert-certificate-to-content", {
        notificationId,
        description,
      });

      window.popupAlert("Published");
      goTo(-1)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
